import { Box, Grid } from "@material-ui/core";
import FormBase from "../../../../forms/FormBase";
import ReRegistrationProfessionalTeamForm, { ReRegistrationProfessionalTeamFormItem } from "../../../../forms/recadastramento/ReRegistrationProfessionalTeamForm";

import TmpTableBaseCustom, { ITableColumnsProps } from "../../../../components/tempo/TmpTableBaseCustom/TmpTableBaseCustom";
import TmpButtonCustom from "../../../../components/tempo/TmpButtonCustom/TmpButtonCustom";
import TmpInputSelectSearchAPICustom from "../../../../components/tempo/TmpInputSelectSearchAPICustom/TmpInputSelectSearchAPICustom";


interface ReRegistrationProfessionalTeamComponentProps {
    ReRegistrationProfessionalTeamForm: ReRegistrationProfessionalTeamForm,
    onInputChange: (name: string, form: FormBase, value: any) => void
    onInserOrUpdateItem: () => void
    onEditClick: (e: ReRegistrationProfessionalTeamFormItem) => void
    onDeleteClick: (e: ReRegistrationProfessionalTeamFormItem) => void
    onCancelItem: () => void
}

export default function ReRegistrationProfessionalTeamComponent(props: ReRegistrationProfessionalTeamComponentProps) {

    const headers: ITableColumnsProps[] = [
        { title: "Equipe", align: "center", property: "Team", type: "text" },
        { title: "Profissão/Ocupação", align: "center", property: "Occupation", type: "text" },
        { title: "Chefe da Equipe", align: "center", property: "Boss", type: "text" },
    ]

    return (

        <Grid container spacing={3}>


            <Grid item xs={7} sm={7}>
                <TmpInputSelectSearchAPICustom
                    label="Equipe *"
                    name="Team"
                    id="Team"
                    placeholder="Pesquise pelo nome da equipe"
                    disabled={props.ReRegistrationProfessionalTeamForm.FormItemToEdit.Id > 0}
                    urlAPI="/sam/v1/medicalTeam/getallteams?textSearch="
                    value={props.ReRegistrationProfessionalTeamForm.Team.Value}
                    onChange={(e) => { props.onInputChange("Team", props.ReRegistrationProfessionalTeamForm, e); }}
                    onBlur={(e) => { props.onInputChange("Team", props.ReRegistrationProfessionalTeamForm, e); }}
                    error={props.ReRegistrationProfessionalTeamForm.Team.HasError()}
                    helperText={props.ReRegistrationProfessionalTeamForm.Team.Error}
                />
            </Grid>

            <Grid item xs={5} sm={5}>
                <TmpInputSelectSearchAPICustom
                    id="Occupation"
                    name="Occupation"
                    label="Sua Profissão/Ocupação na Equipe *"
                    urlAPI="/sam/v1/medicalTeam/getalloccupations?textSearch="
                    maxLength={80}
                    placeholder="Pesque pelo nome da profissão/ocupação"
                    value={props.ReRegistrationProfessionalTeamForm.Occupation.Value}
                    onChange={(e) => { props.onInputChange("Occupation", props.ReRegistrationProfessionalTeamForm, e); }}
                    onBlur={(e) => { props.onInputChange("Occupation", props.ReRegistrationProfessionalTeamForm, e); }}
                    error={props.ReRegistrationProfessionalTeamForm.Occupation.HasError()}
                    helperText={props.ReRegistrationProfessionalTeamForm.Occupation.Error}
                />
            </Grid>

            <Grid item xs={12}>
                <Box style={{ display: "flex", flexDirection: "row-reverse",   alignItems: "flex-end", height: "100%" }}>

                    {(props.ReRegistrationProfessionalTeamForm.FormItemToEdit.Id > 0 ?
                        <TmpButtonCustom id={"cancelar"} type="secondary" typeButton="button" size="sm" handleClick={props.onCancelItem}>
                            Cancelar edição formação profissional
                        </TmpButtonCustom>
                        : null
                    )}

                    {(props.ReRegistrationProfessionalTeamForm.FormItemToEdit.Id === 0 ?
                        <TmpButtonCustom id={"adicionar"} type="primary" typeButton="button" size="sm" handleClick={props.onInserOrUpdateItem}>
                            Vincular equipe ao meu usuário
                        </TmpButtonCustom>
                        :
                        <TmpButtonCustom id={"adicionar"} type="primary" typeButton="button" size="sm" handleClick={props.onInserOrUpdateItem}>
                            Salvar formação profissional
                        </TmpButtonCustom>
                    )}

                </Box>
            </Grid>

            <Grid item xs={12}>
                <TmpTableBaseCustom
                    columns={headers}
                    actionEditColumn={true}
                    actionDeleteColumn={true}
                    onDeleteClick={props.onDeleteClick}
                    onEditClick={props.onEditClick}
                    rows={props.ReRegistrationProfessionalTeamForm.FormItemList}
                />
            </Grid>


        </Grid >

    )

}